import { formActions } from '../actions';

export default function forms(initialState = {}, action ) {
    const newState = {...initialState};
    switch (action.type) {
        case formActions.SET_FORMS: return setForms(newState, action);
        case formActions.SHOW_FORM: return showForm(newState, action);
        default:
            return newState;
    }
}

function setForms(newState, action) {
    delete action.type;

    newState.editing = false;
    newState.Id = null;
    return newState;
}

function showForm(newState, action) {

    delete action.type;

    newState.editing = action.openForm;
    newState.Id = action.Id;

    return newState;
}


// WEBPACK FOOTER //
// src/client/components/site/features/profile/reducers/forms.js